/**
 * Shared Utilities - Moon Moon Agency
 * Essential utilities and helpers shared across all modules
 */

/*********************************************************************************************
 * 🌐 GLOBAL SETTINGS
 */
// Development mode detection
window.isDev = typeof isDevelopment !== 'undefined' ? isDevelopment : false;

// Mobile breakpoint (most commonly used)
window.MOBILE_BREAKPOINT = 768;

/*********************************************************************************************
 * 🛠️ SHARED UTILITIES
 */
// Simple logging utility
window.log = (level, module, message, data = {}) => {
	if (!window.isDev && level === 'info') return;
	if (typeof console !== 'undefined') {
		const logFn = console[level] || console.log;
		const timestamp = window.getTimestamp?.() || new Date().toLocaleString();
		logFn(`${module} ${message}`, { timestamp, ...data });
	}
};

// Simple event emitter
window.emit = (event, detail = {}) => {
	return document.dispatchEvent(new CustomEvent(event, {
		detail: { timestamp: window.getTimestamp?.() || new Date().toLocaleString(), ...detail },
		bubbles: true
	}));
};

// DOM utilities
window.getElement = (selector) => document.querySelector(selector);
window.getElements = (selector) => document.querySelectorAll(selector);

// Common utilities
window.isMobile = () => window.innerWidth <= window.MOBILE_BREAKPOINT;
window.debounce = (fn, delay) => {
	let timeout;
	return (...args) => {
		clearTimeout(timeout);
		timeout = setTimeout(() => fn.apply(this, args), delay);
	};
};

/*********************************************************************************************
 * 🕐 TIMESTAMP UTILITIES
 */
// French timestamp formatter
window.getTimestamp = () => new Date().toLocaleString('fr-FR', {
	year: 'numeric',
	month: '2-digit',
	day: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
	second: '2-digit'
});
